module.exports = __webpack_public_path__ + "static/undraw_game_day_ucx9-e7e18c3d9b173da65e597f701f3478d9.svg";